export interface ScreenRect {
  top: number
  right: number
  bottom: number
  left: number
}

export interface ScreenTranslation {
  x: number
  y: number
}

/**
 * Return the smallest screen-space translation that places `target` inside
 * `container`, leaving `padding` pixels around it. ReactFlow's viewport x/y
 * values are also screen-space translations, so this result can be added to
 * the current viewport without changing zoom or the node's canvas position.
 */
export function getTranslationToRevealRect(
  target: ScreenRect,
  container: ScreenRect,
  padding: number,
): ScreenTranslation {
  const safeLeft = container.left + padding
  const safeRight = container.right - padding
  const safeTop = container.top + padding
  const safeBottom = container.bottom - padding

  let x = 0
  let y = 0

  if (target.left < safeLeft) {
    x = safeLeft - target.left
  } else if (target.right > safeRight) {
    x = safeRight - target.right
  }

  if (target.top < safeTop) {
    y = safeTop - target.top
  } else if (target.bottom > safeBottom) {
    y = safeBottom - target.bottom
  }

  return { x, y }
}
